var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"notification",attrs:{"elevation":"6","width":"400","border":"left","colored-border":"","color":"primary","icon":"mdi-information-outline","prominent":""}},[_vm._v(" "+_vm._s(_vm._f("translate")(_vm.notificationToShow))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }